export function PublicPrototype (pConfig)
{
  return (
  {
    name : 'EditorToolbarPrototypeConfig',

    Groups :
    [
      {
        name : 'HistoryActionsPublic',
        visible : true
      },

      {
        name : 'BlockActionsPublic',
        visible : true
      },

      {
        name : 'TextAlignPublic',
        visible : true
      },

      {
        name : 'FontColorsPublic',
        visible : true
      },

      {
        name : 'InsertPublic',
        visible : true
      },

      {
        name : 'MorePublicActions',
        visible : true
      },

      {
        name : 'BlockStylesPublic',
        lineBreak : true,
        visible : true
      },

      {
        name : 'TextDecorationPublic',
        visible : true
      },

      {
        name : 'TextDecorationDropdownPublic',
        visible : true,
        isDropdown: true
      }
    ]
  });
}